import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { HeaderWrapper, Title, TagsWrapper } from './MyTicketsTabHeader.styled';
import { Add20Regular } from '@fluentui/react-icons';
import { FilterTags } from '../MyTicketsTable/FilterTags/FilterTags';
import { PrimaryButton } from 'src/styles/globalStyles/buttonStyles.styled';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const MyTicketsTabHeader = () => {
  const { toggleAddTicketPopup } = useServiceDeskContext();
  const { themeString } = useContext(TeamsFxContext);

  return (
    <HeaderWrapper themeString={themeString}>
      <Title>My Tickets</Title>
      <TagsWrapper>
        <FilterTags />
      </TagsWrapper>
      <PrimaryButton
        onClick={() => toggleAddTicketPopup(true)}
        size="medium"
        icon={<Add20Regular />}
        iconPosition="before"
      >
        New Ticket
      </PrimaryButton>
    </HeaderWrapper>
  );
};
